import checkAuthenticated from "@/router/middlewares/checkAuthenticated";
import beforeEnterCheck from "@/router/middlewares/beforeEnterCheck";
import DECORATION_TYPES from '@/router/enums/DECORATION_TYPES';

export default [
    {
        path: '/activities',
        name: 'ActivitiesView',
        component: () => import(/* webpackChunkName: "activities-view" */ '@/modules/activities/components/ActivitiesView'),
        meta: {
            moduleId: 'activities',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        beforeEnter: checkAuthenticated,
    },
    {
        path: '/activities/:id',
        name: 'ActivityForm',
        component: () => import(/* webpackChunkName: "activities-form" */ '@/modules/activities/components/ActivityForm'),
        meta: { 
            moduleId: 'activities',
            ignoreModuleCheck: true,
        },
        props: true,
        beforeEnter: beforeEnterCheck,
    },
    {
        path: '/emails',
        name: 'EmailsView',
        component: () => import(/* webpackChunkName: "emails-view" */ '@/modules/activities/components/emails/EmailsView'),
        meta: {
            moduleId: 'emails',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        beforeEnter: checkAuthenticated,
    },
]
